/*
 *
 *  actions
 *
 */

import {
  LOAD_ACTIVITIES_LIST,
  LOAD_ACTIVITIES_LIST_SUCCESS,
  LOAD_ACTIVITIES_LIST_ERROR,
  LOAD_STATE_ACTIVITIES_LIST,
  LOAD_STATE_ACTIVITIES_LIST_SUCCESS,
  LOAD_STATE_ACTIVITIES_LIST_ERROR,
  LOAD_CITY_ACTIVITIES_LIST,
  LOAD_CITY_ACTIVITIES_LIST_SUCCESS,
  LOAD_CITY_ACTIVITIES_LIST_ERROR,
  LOAD_AREA_ACTIVITIES_LIST,
  LOAD_AREA_ACTIVITIES_LIST_SUCCESS,
  LOAD_AREA_ACTIVITIES_LIST_ERROR,
  LOAD_ACTIVITIES_REVIEWS_LIST,
  LOAD_ACTIVITIES_REVIEWS_LIST_SUCCESS,
  LOAD_ACTIVITIES_REVIEWS_LIST_ERROR,
  LOAD_ACTIVITIES_LIST_RECORDS_META_DATA,
  LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_ERROR,
  LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST,
  LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_SUCCESS,
  LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_ERROR,
  LOAD_SIMILAR_AREA_ACTIVITIES_LIST,
  LOAD_SIMILAR_AREA_ACTIVITIES_LIST_SUCCESS,
  LOAD_SIMILAR_AREA_ACTIVITIES_LIST_ERROR,
  LOAD_CAB_DETAILS,
  LOAD_CAB_DETAILS_SUCCESS,
  LOAD_CAB_DETAILS_ERROR,
} from "./constants";

// load activities list
export function loadActivitiesList(destinations) {
  return {
    type: LOAD_ACTIVITIES_LIST,
    destinations,
  };
}

export function loadActivitiesListSuccess(activities_list, success) {
  return {
    type: LOAD_ACTIVITIES_LIST_SUCCESS,
    activities_list,
    success,
  };
}

export function loadActivitiesListError(error) {
  return {
    type: LOAD_ACTIVITIES_LIST_ERROR,
    error,
  };
}

// load activities list
export function loadCabDetailsList(destinations) {
  return {
    type: LOAD_CAB_DETAILS,
    destinations,
  };
}

export function loadCabDetailsListSuccess(cab_details_list, success) {
  return {
    type: LOAD_CAB_DETAILS_SUCCESS,
    cab_details_list,
    success,
  };
}

export function loadCabDetailsListError(error) {
  return {
    type: LOAD_CAB_DETAILS_ERROR,
    error,
  };
}

// load state activities list
export function loadStateActivitiesList(destinations) {
  return {
    type: LOAD_STATE_ACTIVITIES_LIST,
    destinations,
  };
}

export function loadStateActivitiesListSuccess(state_activities_list, success) {
  return {
    type: LOAD_STATE_ACTIVITIES_LIST_SUCCESS,
    state_activities_list,
    success,
  };
}

export function loadStateActivitiesListError(error) {
  return {
    type: LOAD_STATE_ACTIVITIES_LIST_ERROR,
    error,
  };
}

// load city activities list
export function loadCityActivitiesList(destinations) {
  return {
    type: LOAD_CITY_ACTIVITIES_LIST,
    destinations,
  };
}

export function loadCityActivitiesListSuccess(city_activities_list, success) {
  return {
    type: LOAD_CITY_ACTIVITIES_LIST_SUCCESS,
    city_activities_list,
    success,
  };
}

export function loadCityActivitiesListError(error) {
  return {
    type: LOAD_CITY_ACTIVITIES_LIST_ERROR,
    error,
  };
}

// load area activities list
export function loadAreaActivitiesList(destinations) {
  return {
    type: LOAD_AREA_ACTIVITIES_LIST,
    destinations,
  };
}

export function loadAreaActivitiesListSuccess(area_activities_list, success) {
  return {
    type: LOAD_AREA_ACTIVITIES_LIST_SUCCESS,
    area_activities_list,
    success,
  };
}

export function loadAreaActivitiesListError(error) {
  return {
    type: LOAD_AREA_ACTIVITIES_LIST_ERROR,
    error,
  };
}
// similar area activities list
export function loadSimilarAreaPackagesList(destinations) {
  return {
    type: LOAD_SIMILAR_AREA_ACTIVITIES_LIST,
    destinations,
  };
}

export function loadSimilarAreaPackagesListSuccess(similar_packages_list, success) {
  return {
    type: LOAD_SIMILAR_AREA_ACTIVITIES_LIST_SUCCESS,
    similar_packages_list,
    success,
  };
}

export function loadSimilarAreaPackagesListError(error) {
  return {
    type: LOAD_SIMILAR_AREA_ACTIVITIES_LIST_ERROR,
    error,
  };
}

// load activities review list
export function loadActivityReviewsList(destinations) {
  return {
    type: LOAD_ACTIVITIES_REVIEWS_LIST,
    destinations,
  };
}

export function loadActivityReviewsListSuccess(
  activities_reviews_list,
  success
) {
  return {
    type: LOAD_ACTIVITIES_REVIEWS_LIST_SUCCESS,
    activities_reviews_list,
    success,
  };
}

export function loadActivityReviewsListError(error) {
  return {
    type: LOAD_ACTIVITIES_REVIEWS_LIST_ERROR,
    error,
  };
}

// load activities review list
export function loadSingleActivitiesReviewsList(destinations) {
  return {
    type: LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST,
    destinations,
  };
}

export function loadSingleActivitiesReviewsListSuccess(
  single_activities_reviews,
  success
) {
  return {
    type: LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_SUCCESS,
    single_activities_reviews,
    success,
  };
}

export function loadSingleActivitiesReviewsListError(error) {
  return {
    type: LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_ERROR,
    error,
  };
}

export function loadActivitiesListRecordsMetaData() {
  return {
    type: LOAD_ACTIVITIES_LIST_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadActivitiesListRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadActivitiesListRecordsMetaDataError(error) {
  return {
    type: LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadActivitiesList,
  loadActivitiesListSuccess,
  loadActivitiesListError,
  loadCabDetailsList,
  loadCabDetailsListSuccess,
  loadCabDetailsListError,
  loadStateActivitiesList,
  loadStateActivitiesListSuccess,
  loadStateActivitiesListError,
  loadCityActivitiesList,
  loadCityActivitiesListSuccess,
  loadCityActivitiesListError,
  loadAreaActivitiesList,
  loadAreaActivitiesListSuccess,
  loadAreaActivitiesListError,
  loadSimilarAreaPackagesList,
  loadSimilarAreaPackagesListSuccess,
  loadSimilarAreaPackagesListError,
  loadActivityReviewsList,
  loadActivityReviewsListSuccess,
  loadActivityReviewsListError,
  loadSingleActivitiesReviewsList,
  loadSingleActivitiesReviewsListSuccess,
  loadSingleActivitiesReviewsListError,

  loadActivitiesListRecordsMetaData,
  loadActivitiesListRecordsMetaDataSuccess,
  loadActivitiesListRecordsMetaDataError,
};

export default actions;
